/**
 * Module: `export/docx-source-separators.ts` — align Word rules with PDF.
 */

import {
  EXPORT_COLOR_SEPARATOR,
  EXPORT_SEPARATOR_LINE_WIDTH_PT,
  EXPORT_SEPARATOR_MARGIN_PT,
  ptToTwips,
} from "@/lib/export/export-styles";

/** Word stores border widths in eighths of a point. */
const borderSize = Math.round(EXPORT_SEPARATOR_LINE_WIDTH_PT * 8);
const separatorMargin = ptToTwips(EXPORT_SEPARATOR_MARGIN_PT);

/**
 * md2docx emits thematic breaks as unstyled, black 0.75pt top borders.
 * Normalize their color, width and vertical rhythm to the PDF reference.
 */
export function enhanceDocxSourceSeparators(documentXml: string): string {
  return documentXml.replace(
    /<w:p><w:pPr><w:pBdr><w:top\b[^>]*\/><\/w:pBdr><\/w:pPr><\/w:p>/g,
    [
      "<w:p><w:pPr>",
      "<w:pBdr>",
      `<w:top w:val="single" w:sz="${borderSize}" w:space="0" w:color="${EXPORT_COLOR_SEPARATOR}"/>`,
      "</w:pBdr>",
      `<w:spacing w:before="${separatorMargin}" w:after="${separatorMargin}" w:line="1" w:lineRule="exact"/>`,
      "</w:pPr></w:p>",
    ].join("")
  );
}
